/* ProviderIconView.tsx generated by @compiled/babel-plugin v0.37.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._5ral1f51%7B-o-object-fit%3Acontain%3Bobject-fit%3Acontain%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3i7vkz%7Bheight%3A1pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bsb7vkz%7Bwidth%3A1pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0c1o8l%7Bdisplay%3Ainline-block%7D");
import React from 'react';
import type { ProviderIcon } from './useSmartLinkMetadata';
const providerIconImageStyles = null;

/**
 * Renders a provider icon, accepting either a ready-to-render React node
 * (e.g. the Confluence/Jira logo elements returned by `extractSmartLinkProvider`)
 * or a remote image URL (e.g. a third-party provider PNG).
 */
export const ProviderIconView = ({
  icon
}: {
  icon: ProviderIcon | undefined;
}): React.JSX.Element | null => {
  if (!icon) {
    return null;
  }
  if (icon.kind === 'url') {
    return <img src={icon.url} alt="" className={ax(["_1e0c1o8l _1bsb7vkz _4t3i7vkz _5ral1f51"])} />;
  }
  return <React.Fragment>{icon.node}</React.Fragment>;
};